if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENABLE_LOCAL_BOOTSTRAP === "true") {
  import('./local-bootstrap');
}

export {};
